import { useStyle } from "@/context/StyleContext";
import React from "react";

interface PhotoStairsProps {
  photos: any[];
  width?: number | string;
  height?: number | string;
  stepOffset?: number; // px offset for each step
}

const PhotoStairs: React.FC<PhotoStairsProps> = ({
  photos,
  width = 180,
  height = 260,
  stepOffset = 40,
}) => {
  // Only use up to 3 photos
  const displayPhotos = photos.slice(0, 3);

  const { colors, theme } = useStyle();

  const [hoveredIndex, setHoveredIndex] = React.useState<number | null>(null);
  const [visibleArr, setVisibleArr] = React.useState([false, false, false]);

  const [preloadedImages, setPreloaded] = React.useState<any[] | null>(null);

  React.useEffect(() => {
    const preloadedImages = displayPhotos.map((src) => {
      const img = new window.Image();
      img.src = src;
      return img.src;
    });
    setPreloaded(preloadedImages);
  }, [photos]);

  React.useEffect(() => {
    if (!preloadedImages || preloadedImages.length === 0) return;
    preloadedImages.forEach((_, idx) => {
      setTimeout(() => {
        setVisibleArr((prev) => {
          const next = [...prev];
          next[idx] = true;
          return next;
        });
      }, 650 * idx);
    });
  }, [preloadedImages]);

  return (
    <div
      style={{
        position: "relative",
        width:
          typeof width === "number" ? `${width + stepOffset * 2}px` : width,
        height:
          typeof height === "number" ? `${height + stepOffset * 2}px` : height,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {preloadedImages?.map((src, idx) => (
        <img
          onMouseOver={() => setHoveredIndex(idx)}
          onMouseOut={() => setHoveredIndex(null)}
          key={src}
          src={src}
          alt={`Stair ${idx + 1}`}
          style={{
            position: "absolute",
            top: `${idx * stepOffset}px`,
            right: `${idx * stepOffset}px`,
            width: typeof width === "number" ? `${width}px` : width,
            height: typeof height === "number" ? `${height}px` : height,
            objectFit: "cover",
            borderRadius: "18px",
            boxShadow: "0 4px 16px rgba(0,0,0,0.18)",
            zIndex: hoveredIndex === idx ? 10 : idx,
            border: `2px solid ${colors[theme].border}`,
            background: "#eee",
            transition: `box-shadow 0.2s, opacity 1s cubic-bezier(.4,2,.6,1)`,
            opacity: visibleArr[idx] ? 1 : 0,
          }}
        />
      ))}
    </div>
  );
};

export default PhotoStairs;
